import Filter from "../core/Filter";
import FadeAnimation from "./FadeAnimation";
import LazyLoad from "vanilla-lazyload";
import Rellax from "rellax";
import ScrollTo from "@bornfight/b-scroll-to";

export default class TeamModuleFilter extends Filter {
    init(el) {
        this.teamModuleMainWrapper = el.querySelector(".js-team-module-list");
        this.listGrid = el.querySelector(".c-people-list__grid");
        this.teamMemberFilterSelect = el.querySelector(".js-filter-team-member");
        this.teamMemberFilterAlphabet = el.querySelectorAll(".js-filter-alphabetical-team-member");
        this.teamMemberFilterSearch = el.querySelector(".js-filter-team-name");
		this.teamMemberFilterSearchInput = el.querySelector(".js-filter-team-name-input");
        this.enableLoadMore = el.querySelector(".js-enable-load-more");
        this.disablePagination = el.querySelector(".js-disable-pagination");
        this.excludeRoles = el.querySelector(".js-exclude-roles");
        this.loadMoreBtn = el.querySelector('.js-load-more');

        if (this.teamModuleMainWrapper) {
            this.initPagination(el);
            this.initFilters();
        }
    }

    getFilters() {
        let filter = "";

        if (this.teamMemberFilterSelect) {
            let select = this.teamMemberFilterSelect;
            let selectedValue = "";

            for (let i = 0; i < select.length; i++) {
                if (select[i].selected) {
                    selectedValue = select[i].value;
                }
            }

            if (selectedValue) {
                filter += "&team_role=" + selectedValue;
            }
        }

		if (this.teamMemberFilterSearch) {
			let input = this.teamMemberFilterSearchInput;

			if (input.value != "") {
				filter += "&team_name=" + input.value;
			}
		}

        
		if (this.excludeRoles) {

			if (this.excludeRoles.value != "") {
				filter += "&exclude_roles=" + this.excludeRoles.value;
			}
		}


        if(this.teamMemberFilterAlphabet){
            let radios = this.teamMemberFilterAlphabet;

            let radioValue = "";

            radios.forEach(radio => {
                if (radio.checked) {
                    radioValue = radio.value;
                }
            });

            if (radioValue) {
                filter += "&team_letter=" + radioValue;
            }

        }

        if(this.enableLoadMore){

            if (this.enableLoadMore.checked) {
                filter += "&enable_loadmore=1";
            }

        }

        if(this.disablePagination){

            if (this.disablePagination.checked) {
                filter += "&disable_pagination=1";
            }

        }
        return filter;
    }

    initFilters() {
        if (this.teamMemberFilterSelect) {
            this.teamMemberFilterSelect.addEventListener("change", (event) => {
                event.preventDefault();

                if (this.isFilterInProgress()) {
                    return;
                }

                this.disableFilter();
                let select = event.target;

                for (let i = 0; i < select.length; i++) {
                    if (select.value === select[i].value) {
                        select[i].setAttribute("selected", true);
                    }
                }

                this.ajaxFilter(1);
            });
        }

        if(this.teamMemberFilterAlphabet){
            this.teamMemberFilterAlphabet.forEach(radio => radio.addEventListener('change', () => this.ajaxFilter(1)));
        }

        if (this.teamMemberFilterSearch) {
            this.teamMemberFilterSearch.addEventListener("click", (event) => {
                event.preventDefault();

				if (this.isFilterInProgress()) {
					return;
				}

				this.disableFilter();
				let searchInput = this.teamMemberFilterSearchInput.value;

				this.ajaxFilter(1);
            });
        }
    }

    ajaxFilter(page, stateHistory = true) {
        let url = this.getApiUrlFromElement(".js-team-module-list");

        let params =  '?page=' + page ;

        let filters = this.getFilters();
    
        if (filters) {
            params += filters;
        }

        // console.log(params)

        this.loadAjax(url, params, stateHistory);
    }

    afterFilterAjax(response, stateHistory) {
        let data = JSON.parse(response);

        if (data.html) {
            if(this.enableLoadMore.checked){
                
                if(this.teamMemberFilterAlphabet){
                    let radios = this.teamMemberFilterAlphabet;
        
                    let radioValue = "";
        
                    radios.forEach(radio => {
                        if (radio.checked) {
                            radioValue = radio.value;
                        }
                    });
        
                    if (radioValue) {
                        this.listGrid.innerHTML = '';
                    }

                }

                if(data.max_pages){
                    this.listGrid.setAttribute('data-max-pages', data.max_pages);
                }
                
                this.listGrid.insertAdjacentHTML('beforeend',data.html);
                let currPage = parseInt(this.loadMoreBtn.getAttribute('data-val'));
                let nextPage = currPage + 1;
                if(nextPage > parseInt(this.listGrid.getAttribute('data-max-pages'))){
                    this.loadMoreBtn.style.display = 'none';
                }else{
                    this.loadMoreBtn.setAttribute('data-val', nextPage);
                }
                
            }else{
                this.teamModuleMainWrapper.innerHTML = data.html;
            }
  
        }

        if (data.url && stateHistory) {
            let stateData = {
                page: data.page,
                url: data.url,
                random: Math.random(),
                source: "swup",
            };

            this.updateUrls(stateData, data.url);
        }

        this.enableFilter();

        this.initPagination();

        const fadeAnimation = new FadeAnimation();
        fadeAnimation.init();
        new ScrollTo({
            duration: 0.5,
        });

        /**
         * Lazyload init
         */
        const lazyLoad = new LazyLoad({
            elements_selector: ".js-lazy",
        });

        /**
         * parallax init
         */
        // const rellax = new Rellax(".rellax", {
        //     speed: -2,
        //     center: true,
        //     wrapper: null,
        //     round: true,
        //     vertical: true,
        //     horizontal: false,
        // });
    }
}